import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import Loader from '~/src/common/components/Loader';
import SeoCms from '~/src/common/components/Seo/SeoCms';
import { PageContent, getPageModelEntry } from '~/src/common/services/Builder';
import { withEnhancedGSSP } from '~/src/common/services/Networking/server/withEnhancedGSSP';
import { useGetMarketingBySlugQuery } from '~/src/queries/cms/generated/cms';
import InfoScreen from '~/src/screens/InfoScreen/InfoScreen';

const PAGE_MODEL = 'info';

const InfoPage = () => {
  const { asPath: path, query } = useRouter();

  const slug = String(query.slug);

  // Par défaut, on check Builder
  const { data: dataBuilder, isLoading: isLoadingBuilder } = useQuery(
    ...getPageModelEntry(PAGE_MODEL, path),
  );

  // En fallback, on utilise ce qui est disponible sur Strapi
  const { data: dataStrapi, isLoading: isLoadingStrapi } = useGetMarketingBySlugQuery(
    { info_slug: slug },
    { enabled: dataBuilder == null && !isLoadingBuilder },
  );
  const infoStrapi = dataStrapi?.modaleMarketings?.[0];

  // Petits helpers
  const showBuilder = dataBuilder != null;
  const showStrapi = !showBuilder && dataStrapi != null;
  const showLoader = isLoadingBuilder || isLoadingStrapi || (!showBuilder && !showStrapi);

  return (
    <>
      <SeoCms data={dataBuilder?.data} />
      {showLoader ? <Loader /> : null}
      {dataBuilder ? <PageContent model={PAGE_MODEL} content={dataBuilder} /> : null}
      {infoStrapi ? <InfoScreen slug={slug} info={infoStrapi} /> : null}
    </>
  );
};

export const getServerSideProps = withEnhancedGSSP(
  async ({ resolvedUrl, query }, { prefetch, notFound }) => {
    // Skip le prefetch si builder est en mode preview
    if ('builder.preview' in query) return;

    const slug = String(query.slug);

    // Chargement des catégories principales
    // Actuellement les pages d'infos peuvent être issues soit de Strapi soit de Builder
    const pBuilderInfos = prefetch(...getPageModelEntry(PAGE_MODEL, resolvedUrl));
    const pStrapiInfos = prefetch(
      useGetMarketingBySlugQuery.getKey({ info_slug: slug }),
      useGetMarketingBySlugQuery.fetcher({ info_slug: slug }),
    );

    // Attente de la fin des requêtes
    const [strapiInfos, builderInfos] = await Promise.all([pStrapiInfos, pBuilderInfos]);

    const strapiMktInfos = strapiInfos?.modaleMarketings?.[0];

    if (strapiMktInfos || builderInfos) return;

    // S'il n'y a aucune info ni de Strapi ni de Builder on renvoie une 404
    notFound();
  },
);

export default InfoPage;
